import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchBonus, createBonus, updateBonus, deleteBonus } from "./thunks";
import { Bonus } from "@/types";
import { toast } from "react-toastify";

interface Paginatedbonus {
  data: Bonus[];
  total?: number;
  currentPage?: number;
  perPage?: number;
}

interface BonusState {
  bonus: Paginatedbonus;
  loading: boolean;
  error: string | null;
}

const initialState: BonusState = {
  bonus: { data: [] },
  loading: false,
  error: null,
};

const ExpenseSlice = createSlice({
  name: "bonus",
  initialState,
  reducers: {
    clearSuppliers: (state) => {
      state.bonus = { data: [] };
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchBonus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBonus.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        const payload = action.payload;

        if (Array.isArray(payload.data)) {
          // Dados não paginados
          state.bonus = { data: payload.data };
        } else {
          // Dados paginados
          state.bonus = {
            data: payload.data.data,
            total: payload.data.total,
            currentPage: payload.data.current_page,
            perPage: payload.data.per_page,
          };
        }
      })
      .addCase(fetchBonus.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
      })
      // Create
      .addCase(createBonus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createBonus.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.bonus.data.push(action.payload.data);
        toast.success("Bonus cadastrado com sucesso!");
      })
      .addCase(createBonus.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
        toast.error("Não foi possível criar o bonus, tente novamente!");
      })

      // Update
      .addCase(updateBonus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateBonus.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        const index = state.bonus.data.findIndex(
          (s) => s.id == action.payload.data.id,
        );
        if (index !== -1) {
          state.bonus.data[index] = action.payload.data;
        }
        toast.success("Bonus atualizado com sucesso!");
      })
      .addCase(updateBonus.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
        console.log("error", state.error);
        toast.error("Error");
      })

      // Delete
      .addCase(deleteBonus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteBonus.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.bonus.data = state.bonus.data.filter(
          (s) => String(s.id) != action.payload.data.id,
        );
        toast.success("Bonus excluído com sucesso!");
      })
      .addCase(deleteBonus.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
      });
  },
});

export default ExpenseSlice.reducer;
